<template>

    <ModalBack class="modal " :class="{'is-active': realOpen}" :pose="isOpen ? 'visible' : 'hidden'">
        <div class="modal-background" @click="cancelClicked"></div>
        <ModalCard class="modal-card" :pose="isOpen ? 'visible' : 'hidden'">
            <header class="modal-card-head"  >
                <p class="modal-card-title" v-if="modalTitle" >{{modalTitle}}</p>
                <button class="delete removeModal" aria-label="close" @click="cancelClicked"></button>
            </header>
            <section class="modal-card-body">
                <slot/>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-outlined"
                    v-if="cancelLabel"
                    :class="cancelClass"
                    @click="cancelClicked">
                    {{ cancelLabel }}
                </button>
                <button class="modal_confirm_button button is-outlined" 
                    :disabled="isDisabled" 
                    :class="buildConfirmClass" 
                    @click="confirmClicked"
                    v-if="confirmLabel">
                    {{ confirmLabel }}
                </button>
            </footer>
        </ModalCard>
    </ModalBack>

</template>



<script>
import posed from 'vue-pose';


export default {
    name: 'Modal',
    inject: ['$validator'],
    props: {
        modalTitle: {
            default: false
        },
        cancelLabel: {
            default: function(){
                return this.$i18n.t("layouts.global.cancel")
            }
        },
        confirmLabel: {
            default: function(){
                return this.$i18n.t("layouts.global.validate")
            }
        },
        cancelClass: {
            default: "is-danger"
        },
        confirmClass: {
            default: "is-info"
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isOpen: {
            default: false
        }
    },
    components: {
        ModalBack: posed.div({
            visible: {
                opacity: 1,
            },
            hidden: {
                opacity: 0,
            }
        }),
        ModalCard: posed.div({
            visible: { opacity: 1, scale: 1 },
            hidden: { opacity: 0, scale: 0 },
        })
    },
    data(){
        return {
            realOpen: false
        }
    },
    computed: {
        buildConfirmClass(){
            if (this.isLoading){
                return 'is-loading ' + this.confirmClass
            }else{
                return this.confirmClass
            }
        }        
    },
    methods: {
        confirmClicked(){
            let hasErrors = false
            this.$children[0].$children[0].$validator.validateAll()
            setTimeout(() => {
                if (this.$children[0].$children[0].errors && this.$children[0].$children[0].errors.items.length > 0){
                    hasErrors = true
                }
                this.$emit('onConfirm', hasErrors)
            }, 100)
        },
        cancelClicked(){
            this.$emit('onClose')
        }
    },
    watch: {
        isOpen: {
            handler: function(newVal, oldVal){
                if(newVal == false){

                    setTimeout(() => {
                        this.realOpen = newVal
                    }, 300)
                }else{
                    this.$emit('onOpen')
                    this.realOpen = newVal
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-card{
    border-radius: 5px;
}
.modal-card-head{
    justify-content: flex-end;
}
.modal_confirm_button{
    &:focus{
        background: transparent!important;
    }
}
.modal-card-foot{
    justify-content: flex-end;
}
</style>